export { default } from './merchandising-message'
